import React from 'react';
import logoImage from '../assets/logo.png';

const Logo = ({ size = 150, showText = false }) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      alignItems: 'center'
    }}>
      <img 
        src={logoImage} 
        alt="PrepNest Logo" 
        style={{
          width: size,
          height: 'auto',
          objectFit: 'contain'
        }}
      />
    </div>
  );
};

export default Logo; 